import Testimonial from '../../block/testimonial/Component';
import { PropsFromInputs } from '../../types';

import { Container, Content, Scroller, Title } from './layout';

type Props = PropsFromInputs<typeof import('./inputs').default>;

export default ({ title, image, items }: Props) => {
  return (
    <Container>
      <Title>
        <img src={image} alt="" />
        <h2>{title}</h2>
      </Title>
      <Scroller>
        <Content>
          {items.map(item => (
            <Testimonial key={`${item.name}-${item.title}`} {...item} />
          ))}
        </Content>
      </Scroller>
    </Container>
  );
};
